<template>
  <dv-full-screen-container class="bg">
    <div class="title_box">
      <div class="c_title">
        {{ systemName }}
      </div>
      <div class="flexBox">
        <div class="l_title">
          {{ dateYear }} <span>{{ dateDay }} {{ dateWeek }}</span>
        </div>
        <div class="r_title">{{ systemName }}</div>
      </div>
    </div>
    <div class="main-container">
      <div class="conL">
        <div class="conL-scjyxx">
          <div class="conL-tit">
            牲畜交易信息
            <!-- <span>2021年06月10日 13:23</span> -->
          </div>
          <div class="conL-scjyxx-info">
            <ul class="flexBox tableT">
              <li>名称</li>
              <li>畜种</li>
              <li>等级</li>
              <li>数量</li>
            </ul>
            <div v-if="
              listScjyxx.length > 0 &&
              listScjyxx != undefined &&
              listScjyxx != null
            " class="marquee">
              <vue-seamless-scroll :data="listScjyxx" class="seamless-warp" :class-option="classOptionScjy">
                <ul class="item">
                  <li v-for="(item, i) in listScjyxx" :key="i" class="flexBox">
                    <div v-text="item.batchName" :title="item.batchName"></div>
                    <div v-text="item.livestockTypeInfo.livestockTypeName"></div>
                    <div v-text="item.livestockLevelInfo.livestockLevelName"></div>
                    <div>
                      {{ item.livestockNum
                      }}{{ item.livestockTypeInfo.livestockTypeUnit }}
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
            <div v-else class="noInfo">暂无数据</div>
          </div>
          <div class="conL-scjyxx-txt">
            今日成交量:<span>{{ todayData }}笔</span> 成交总量:<span>{{ totalData }}笔</span>
          </div>
        </div>
        <div class="conL-jpxx">
          <div class="conL-tit">举牌信息</div>
          <div class="conL-jpxx-con">
            <ul class="flexBox tableT">
              <li>竞拍批次</li>
              <li>举牌人(单位)</li>
              <li>举牌价</li>
            </ul>
            <div v-if="
              listJpxx.length > 0 && listJpxx != undefined && listJpxx != null
            " class="marquee conL-jpxx-info">
              <vue-seamless-scroll :data="listJpxx" class="seamless-warp" :class-option="classOptionJp">
                <ul class="item">
                  <li v-for="(item, i) in listJpxx" :key="i" class="flexBox">
                    <div v-text="item.batchInfo ? item.batchInfo.batchName : '--'"></div>
                    <div v-text="item.buyerInfo ? item.buyerInfo.userName : '--'"
                      :title="item.buyerInfo ? item.buyerInfo.userName : '--'"></div>
                    <div v-text="item.biddingPrice"></div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
            <div v-else class="noInfo">暂无数据</div>
          </div>
        </div>
        <div class="conL-cjjj">
          <div class="conL-tit">成交记录</div>
          <div class="conL-cjjj-con">
            <ul class="flexBox tableT">
              <li>竞拍批次</li>
              <li>成交人(单位)</li>
              <li>成交价</li>
              <li>成交日期</li>
            </ul>
            <div v-if="
              listCjjj.length > 0 &&
              listCjjj !== undefined &&
              listCjjj !== null
            " class="marquee conL-cjjj-info">
              <vue-seamless-scroll :data="listCjjj" class="seamless-warp" :class-option="classOptionCjjj">
                <ul class="item">
                  <li v-for="(item, i) in listCjjj" :key="i" class="flexBox">
                    <div v-text="item.batchInfo ? item.batchInfo.batchName : '--'"></div>
                    <div v-text="item.buyerInfo ? item.buyerInfo.userName : '--'"
                      :title="item.buyerInfo ? item.buyerInfo.userName : '--'"></div>
                    <div v-text="item.tradingPrice"></div>
                    <div>
                      {{ item.createTime | formatTime("yyyy-MM-dd HH:mm:ss") }}
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
            <div v-else class="noInfo">暂无数据</div>
          </div>
        </div>
        <div class="conL-sgfxx">
          <div class="conL-tit">收购方信息</div>
          <div class="conL-sgfxx-con">
            <div v-if="
              sellers.length > 0 && sellers != undefined && sellers != null
            " class="marquee conL-sgfxx-info">
              <vue-seamless-scroll :data="sellers" class="seamless-warp" :class-option="classOptionSgfxx">
                <ul class="item">
                  <li v-for="(item, i) in sellers" :key="i" :title="item.userName">
                    {{ item.userName }}
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
            <div v-else class="noInfo">暂无数据</div>
          </div>
        </div>
      </div>
      <div class="conC">
        <div class="videoC" v-show="hasVideoUrl">
          <!-- <video
            id="myVideo"
            class="video-js vjs-default-skin vjs-big-play-centered"
            :class="{ hide: !hasVideoUrl }"
            autoplay
            muted
          >
            <source :src="videoUrl" />
          </video> -->
          <!-- <video class="video-js vjs-default-skin vjs-big-play-centered" autoplay muted controls="false" width="100%"
            height="100%" :src="videoUrl"></video> -->
          <player :video-url="videoUrl" :has-audio="true" :autoplay="true" :isFullResize="true"
            style="width:100%;height:100%;position: absolute;right: 0;left: 0;"
            v-if="videoUrl" :index="swiperI" />
          <div class="ears-box" v-if="
            earLabels != undefined &&
            earLabels != null &&
            earLabels.length > 0
          ">
            <div class="tit">{{ activeBatchInfo.batchName }}-耳标列表</div>
            <vue-seamless-scroll :data="earLabels" class="seamless-warp" :class-option="classOptionEar">
              <ul class="item">
                <li v-for="(item, i) in earLabels" :key="i" class="flexBox">
                  <div v-text="item.earlabel"></div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
        <div v-show="!hasVideoUrl" class="noVideo">
          <p>当前暂无竞拍</p>
        </div>
        <!-- 弹幕容器 -->
        <vue-baberrage :isShow="barrageIsShow" :barrageList="barrageList" :maxWordCount="maxWordCount"
          :throttleGap="throttleGap" :loop="barrageLoop" :boxHeight="boxHeight" :boxWidth="boxWidth"
          :messageHeight="messageHeight" :lanesCount="lanesCount" class="barrage">
        </vue-baberrage>
        <div class="videoInfo" v-if="activeBatchInfo">
          <ul class="flexBox">
            <li>批次名称:{{ activeBatchInfo.batchName }}</li>
            <li>出售方:{{ activeBatchInfo.sellerInfo.sellerName }}</li>
          </ul>
          <ul class="flexBox moreInfo">
            <li>
              平均重量:{{
                (
                  activeBatchInfo.livestockWeight / activeBatchInfo.livestockNum
                ).toFixed(2)
              }}kg
              <label>总重量:{{ activeBatchInfo.livestockWeight }}kg</label>
              <label>育龄:{{ activeBatchInfo.childbearingAge }}</label>
              <label>活畜数量:{{ activeBatchInfo.livestockNum }}</label>
            </li>
            <!-- <li>联系电话:{{ activeBatchInfo.Telephone }}</li> -->
          </ul>
          <ul class="flexBox">
            <li>
              活畜种类:{{ activeBatchInfo.livestockTypeInfo.livestockTypeName }}
              <label>活畜等级:{{
                activeBatchInfo.livestockLevelInfo.livestockLevelName
              }}</label>
              <label>养殖模式:{{
                activeBatchInfo.cultivationModeInfo.cultivationModeName
              }}</label>
            </li>
            <li>
              合格证类型:{{
                activeBatchInfo.certificateTypeInfo.certificateTypeName
              }}
            </li>
          </ul>
        </div>
        <div v-else class="noInfo">暂无数据</div>
      </div>
      <div class="conR">
        <div class="swiper-container active" ref="swiper">
          <ul class="videoList swiper-wrapper" v-if="videoList.length > 0">
            <li class="swiper-slide" v-for="(item, i) in videoList" :key="i"
              :class="swiperI == i && videoList.length <= 4 ? 'active' : ''">
              <!-- <el-image fit="cover" :src="imgurl+item.LiveImg" style="width:100%;height:100%">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image> -->
              <img :src="LIVEIMG_URL +
                item.inFenceList[0].sipId +
                '_' +
                item.inFenceList[0].videoId +
                LIVEIMG_TYPE
                " alt="" style="width: 100%; height: 100%" />
              <div class="videoMask">
                <ul class="maskTop">
                  <li>{{ item.batchName }}</li>
                  <li>
                    <span v-for="(temp, index) in item.inFenceList" :key="index">{{ temp.creamName }}</span>
                  </li>
                </ul>
                <ul class="maskBottom flexBox">
                  <li>
                    活畜数量：{{ item.livestockNum }}({{
                      item.livestockTypeInfo.livestockTypeUnit
                    }})
                  </li>
                  <li>总重量：{{ item.livestockWeight }}kg</li>
                  <li>
                    平均重量：{{
                      (item.livestockWeight / item.livestockNum).toFixed(2)
                    }}kg
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <div v-else class="noInfo">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="successInfo" v-if="isSuccess">
      恭喜{{ successInfo }}竞拍成功！
    </div>
  </dv-full-screen-container>
</template>
<script defer="true">
// import $ from 'jquery';
import { MESSAGE_TYPE } from "vue-baberrage";
import vueSeamlessScroll from "vue-seamless-scroll";
import { formatTime } from "../utils/fdate.js";
import request from "../utils/request";
import Vue from "vue";
// import videojs from "video.js";
import player from './jessibucaPlayer/jessibuca.vue'
export default {

  data() {
    return {
      // VIDEO_URL: Vue.prototype.VIDEO_URL,
      VIDEO_URL: "",
      VIDEO_TYPE: Vue.prototype.VIDEO_TYPE,
      // LIVEIMG_URL: Vue.prototype.LIVEIMG_URL,
      LIVEIMG_URL: "",
      LIVEIMG_TYPE: Vue.prototype.LIVEIMG_TYPE,
      imgurl: Vue.prototype.IMG_URL,
      systemName: "",
      PlaceName: "",
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      totalData: 0,
      todayData: 0,
      weekday: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      listScjyxx: [],
      listJpxx: [],
      listCjjj: [],
      sellers: [],
      activeBatchInfo: null,
      videoList: [],
      myPlayer: null,
      myswiper: null,
      videoUrl: null,
      swiperI: 0,
      timer: null,
      btn_send: null,
      barrageIsShow: true, //是否展示弹幕
      messageHeight: 3, //消息高度(测试不生效)
      barrageLoop: false, //是否循环播放
      maxWordCount: 200, //弹幕字数(测试不生效)
      lanesCount: 2, //固定弹幕(测试不生效)
      boxWidth: 995, //弹幕宽度
      boxHeight: 745, //弹幕高度(测试不生效)
      throttleGap: 600, //消息间隔
      barrageList: [], //弹幕列表，格式为数组
      hasVideoUrl: false,
      isSuccess: false, //是否竞拍成功
      successInfo: "",
      earLabels: [], //耳标
      activeId: 0,
    };
  },
  components: {
    vueSeamlessScroll,
    player
  },
  watch: {
    hasVideoUrl: {
      deep: true, //深度监听
      handler(val) {
        this.hasVideoUrl = val;
      },
    },
  },
  computed: {
    classOptionScjy() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 7, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    classOptionJp() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    classOptionEar() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    classOptionCjjj() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    classOptionSgfxx() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted() {
    this.systemName = Vue.prototype.SYS_Name;
    this.init();
    this.timeFn();
    this.getUrlData();
    this.getBiddingRecordToFenceList();
    this.getSellers();
    // this.getBiddingRecordList();
    // let that = this;
    // setInterval(function () {
    //   //3分钟刷一次
    //   that.getBiddingRecordList();
    // }, 180000);
    this.getClinchDealStatistical();
    this.getRaisingList();
    this.getClinchDealList();
  },
  methods: {
    toSuccess() {
      let that = this;
      that.isSuccess = true;
      that.$confetti.start();
      setTimeout(function () {
        that.isSuccess = false;
        that.$confetti.stop();
      }, 6000);
    },
    timeFn() {
      setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy年MM月dd日");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    init: function () {
      this.path = Vue.prototype.WEB_Socket;
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.path);
        // socket连接前先断开
        this.socket.onclose = this.close;
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
      }
    },
    async videoHLSURL(urldata) {
      this.myPlayer = videojs("myVideo", {
        bigPlayButton: true,
        textTrackDisplay: false,
        posterImage: false,
        errorDisplay: false,
        loop: true,
        autoplay: true,
        hls: {
          withCredentials: false,
        },
      });
      this.myPlayer.src({
        src: urldata,
      });
    },
    initVideo(val) {
      // 初始化视频方法
      var that = this;
      setTimeout(() => {
        that.videoHLSURL(val);
      }, 300);
    },
    initSwiper() {
      let that = this;
      that.timer = null;
      setTimeout(() => {
        if (that.videoList.length <= 4) {
          that.timer = setInterval(() => {
            var i = ++that.swiperI;
            if (i < that.videoList.length) {
              that.activeBatchInfo = that.videoList[i];

              if (that.activeBatchInfo.inFenceList.length > 0) {
                that.hasVideoUrl = true;
                // that.videoUrl =
                //   that.VIDEO_URL +
                //   that.activeBatchInfo.inFenceList[0].sipId +
                //   "_" +
                //   that.activeBatchInfo.inFenceList[0].videoId +
                //   that.VIDEO_TYPE;
                let query = { device_id: that.activeBatchInfo.inFenceList[0].videoId, channel_id: that.activeBatchInfo.inFenceList[0].sipId };
                // 视频地址
                request
                  .fetchGet("develop/ivm/oneDeviceLiveUrl", query)
                  .then((res) => {
                    that.videoUrl = res.data.data.liveUrl;
                  });
                
                that.activeId = i;
              } else {
                that.videoUrl = null;
                that.hasVideoUrl = false;
              }
            } else {
              that.swiperI = 0;
              i = 0;

              that.activeBatchInfo = that.videoList[0];
              if (that.activeBatchInfo.inFenceList.length > 0) {
                  that.hasVideoUrl = true;
                // that.videoUrl =
                //   that.VIDEO_URL +
                //   that.activeBatchInfo.inFenceList[0].sipId +
                //   "_" +
                //   that.activeBatchInfo.inFenceList[0].videoId +
                //   that.VIDEO_TYPE;
                let query = { device_id: that.activeBatchInfo.inFenceList[0].videoId, channel_id: that.activeBatchInfo.inFenceList[0].sipId };
                // 视频地址
                request
                  .fetchGet("develop/ivm/oneDeviceLiveUrl", query)
                  .then((res) => {
                    that.videoUrl = res.data.data.liveUrl;
                  });
                that.activeId = i;
              
                // that.initVideo(that.videoUrl);
              } else {
                that.hasVideoUrl = false;
              }
            }
            that.getEarLabels(that.activeBatchInfo.batchId);
          }, 20000);
        } else {
          that.myswiper = new that.$swiper(that.$refs.swiper, {
            loop: true,
            autoplay: 8000,
            slidesPerView: 4,
            direction: "vertical",
            onSlideChangeStart: function (swiper) {
              var i = swiper.realIndex;
              that.activeId = i;
              that.activeBatchInfo = that.videoList[i];
              that.getEarLabels(that.activeBatchInfo.batchId);
              if (
                that.videoList[i].inFenceList.length > 0 &&
                that.videoList[i].inFenceList[0].videoId
              ) {
                // that.videoUrl =
                //   that.VIDEO_URL +
                //   that.videoList[i].inFenceList[0].sipId +
                //   "_" +
                //   that.videoList[i].inFenceList[0].videoId +
                //   that.VIDEO_TYPE;
                  that.hasVideoUrl = true;
                let query = { device_id: that.videoList[i].inFenceList[0].videoId, channel_id: that.videoList[i].inFenceList[0].sipId };
                // 视频地址
                request
                  .fetchGet("develop/ivm/oneDeviceLiveUrl", query)
                  .then((res) => {
                    that.videoUrl = res.data.data.liveUrl;
                  });
              
                // that.hasVideoUrl = true;
                // that.videoUrl =
                //   that.VIDEO_URL +
                //   that.videoList[i].FenceList[0].VIdeoID +
                //   "_" +
                //   that.videoList[i].FenceList[0].SIPID +
                //   that.VIDEO_TYPE;
                // that.initVideo(that.videoUrl);
              } else {
                that.hasVideoUrl = false;
                that.videoUrl = null;
              }
            },
          });
        }
      }, 500);
    },
    close: function () {
      console.log("断开socket连接");
    },
    open: function () {
      console.log("socket连接成功");
    },
    error: function () {
      console.log("连接错误");
    },
    getMessage: function (msg) {
      console.log(msg);
      this.code = JSON.parse(msg.data).code;
      let res = JSON.parse(msg.data).message;
      let that = this;
      if (this.code == 1001) {
        //链接成功时的返回
      }

      if (this.code == 3001) {
        //竞拍成功信息
        let bidding = JSON.parse(res);
        this.barrageList.push({
          id: Math.floor(Math.random() * 10 + 1), //弹幕ID
          msg: bidding.BatchName + "批次,竞拍成功！", //弹幕消息
          time: 12, //屏幕展示时间
          type: MESSAGE_TYPE.NORMAL, //类型
          barrageStyle: "bitem mar" + Math.floor(Math.random() * 10 + 1), //自定义样式
        });
        let index = that.videoList
          .map((item) => item.BatchID)
          .indexOf(bidding.BatchID);
        this.videoList.splice(index, 1);
        this.listScjyxx.splice(index, 1);
        this.listCjjj.push(bidding);
        this.todayData = this.todayData + 1;
        this.totalData = this.totalData + 1;
        this.successInfo = bidding.BatchName;
        // this.successInfo=bidding.UserName+'在【'+bidding.BatchName+'】' //3001 未返回买家名字UserName
        this.toSuccess();
      }
      if (this.code == 3002) {
        //竞拍流拍
        let bidding = JSON.parse(res);
        this.barrageList.push({
          id: Math.floor(Math.random() * 10 + 1), //弹幕ID
          msg: bidding.BatchName + "批次,竞拍已流拍！", //弹幕消息
          time: 12, //屏幕展示时间
          type: MESSAGE_TYPE.NORMAL, //类型
          barrageStyle: "bitem mar" + Math.floor(Math.random() * 10 + 6), //自定义样式
        });
        let index = that.videoList
          .map((item) => item.BatchID)
          .indexOf(bidding.BatchID);
        this.videoList.splice(index, 1);
        this.listScjyxx.splice(index, 1);
      }
      if (this.code == 4001) {
        //弹幕信息
        let list = {
          id: 1,
          // sellerName: JSON.parse(res).UserName,
          // msg: JSON.parse(res).Barrage,
          msg: res,
        };
        this.sendB(list);
      }
      if (this.code == 3003) {
        // 有人竞价
        let batchInfo = JSON.parse(res);
        this.barrageList.push({
          id: Math.floor(Math.random() * 10 + 1), //弹幕ID
          msg:
            batchInfo.UserName +
            "在【" +
            batchInfo.BatchName +
            "】批次竞拍中最新出价" +
            batchInfo.BiddingPrice +
            "元", //弹幕消息
          time: 12, //屏幕展示时间
          type: MESSAGE_TYPE.NORMAL, //类型
          barrageStyle: "bitem mar" + Math.floor(Math.random() * 10 + 3), //自定义样式
        });
        this.listJpxx.push(batchInfo);
      }
      if (this.code == 2002) {
        // 有当天的新的竞拍加入时
        let newBatch = JSON.parse(res);
        this.barrageList.push({
          id: Math.floor(Math.random() * 10 + 1), //弹幕ID
          msg: "【" + newBatch.BatchName + "】批次竞拍开始啦！", //弹幕消息
          time: 12, //屏幕展示时间
          type: MESSAGE_TYPE.NORMAL, //类型
          barrageStyle: "bitem mar" + Math.floor(Math.random() * 10 + 8), //自定义样式
        });
        if (newBatch.FenceList.length > 0) {
          that.videoUrl = newBatch.FenceList[0].Hls;
          that.hasVideoUrl = true;
        }

        this.videoList.push(newBatch);
        this.initSwiper();
        if (this.videoList.length == 1) {
          //当前只有一个竞拍，就将新加入的竞拍信息展示在视频下方
          this.activeBatchInfo = newBatch;
        }
      }
    },
    send: function (params) {
      this.socket.send(params);
    },
    close: function () {
      console.log("socket已经关闭");
    },
    sendB: function (list) {
      // this.barrageList.push({
      //   id: list.id, //弹幕ID
      //   msg: list.sellerName + ":" + list.msg, //弹幕消息
      //   time: 12, //屏幕展示时间
      //   type: MESSAGE_TYPE.NORMAL, //类型
      //   barrageStyle: "bitem mar" + Math.floor(Math.random() * 10 + 1), //自定义样式
      // });
      this.barrageList.push({
        id: list.id, //弹幕ID
        msg: list.msg, //弹幕消息
        time: 12, //屏幕展示时间
        type: MESSAGE_TYPE.NORMAL, //类型
        barrageStyle: "bitem mar" + Math.floor(Math.random() * 10 + 1), //自定义样式
      });
    },
    getSellers: function () {
      let query = { pageNum: 1, pageSize: 10, auditState: "1" };
      request
        .fetchGet("develop/visualization/buyerList", query)
        .then((res) => {
          if (res.data.total > 0) {
            this.sellers = res.data.rows;
          }
        })
        .catch();
    },
    getBiddingRecordToFenceList: function () {
      let query = { biddingState: 2 };
      request.fetchGet("develop/visualization/batchList", query).then((res) => {
        this.videoList = res.data.rows;
        this.listScjyxx = res.data.rows;
        if (this.videoList.length > 0) {
          this.hasVideoUrl = true;
          this.activeBatchInfo = res.data.rows[0];
          if (this.activeBatchInfo.inFenceList.length > 0) {
            // this.videoUrl =
            //   this.VIDEO_URL +
            //   this.activeBatchInfo.inFenceList[0].sipId +
            //   "_" +
            //   this.activeBatchInfo.inFenceList[0].videoId +
            //   this.VIDEO_TYPE;
            let query = { device_id: this.activeBatchInfo.inFenceList[0].videoId, channel_id: this.activeBatchInfo.inFenceList[0].sipId };
            // 视频地址
            request
              .fetchGet("develop/ivm/oneDeviceLiveUrl", query)
              .then((res) => {
                this.videoUrl = res.data.data.liveUrl;
              });
            
          }
          // this.initVideo(this.videoUrl);
          this.initSwiper();
          this.getEarLabels(this.activeBatchInfo.batchId);
        }
        console.log("视频地址", this.videoUrl);
      });
    },
    getUrlData: function () {
      // let query = { configKey: "sys.video" };
      // // 视频地址
      // request
      //   .fetchGet("develop/visualization/getInfoByKey", query)
      //   .then((res) => {
      //     this.VIDEO_URL = res.data.data.configValue;
      //   });

      let data = {
        configKey: "sys.video.cover",
      };
      // 图片地址
      request
        .fetchGet("develop/visualization/getInfoByKey", data)
        .then((res) => {
          this.LIVEIMG_URL = res.data.data.configValue;
        });
    },
    //获取正在竞拍和竞拍预告列表
    getBiddingRecordList: function () {
      // request.fetchGet("api/GetBiddingRecordList").then((res) => {
      //   this.listScjyxx = res.data;
      // });
    },
    //获取今日成交量和总成交量
    getClinchDealStatistical: function () {
      request
        .fetchGet("develop/statistics/getStatisticsAuction")
        .then((res) => {
          this.todayData = res.data.data.fixtureNumberToday
            ? res.data.data.fixtureNumberToday
            : 0;
          this.totalData = res.data.data.fixtureNumber
            ? res.data.data.fixtureNumber
            : 0;
        });
    },
    //获取举牌列表
    getRaisingList: function () {
      request.fetchGet("develop/visualization/biddingList").then((res) => {
        this.listJpxx = res.data.rows;
      });
    },
    //获取成交记录列表
    getClinchDealList: function () {
      request.fetchGet("develop/visualization/tradingList").then((res) => {
        this.listCjjj = res.data.rows;
      });
    },
    // 获取耳标信息
    getEarLabels(batchId) {
      let query = { batchId: batchId };
      request
        .fetchGet("develop/visualization/earlabelReadList", query)
        .then((res) => {
          this.earLabels = res.data.rows;
        });
    },
  },

  destroyed() {
    // 销毁监听
    this.socket.onclose = this.close;
    clearInterval(this.timer);
  },
};
</script>

<style>
@import "../assets/css/style.css";
@import "../assets/fonts/icomoon.css";

video::-webkit-media-controls-fullscreen-button {
  display: none;
}

video::-webkit-media-controls-play-button {
  display: none;
}

video::-webkit-media-controls-timeline {
  display: none;
}

video::-webkit-media-controls-current-time-display {
  display: none;
}

video::-webkit-media-controls-time-remaining-display {
  display: none;
}

video::-webkit-media-controls-mute-button {
  display: none;
}

video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}

video::-webkit-media-controls-volume-slider {
  display: none;
}

video::-webkit-media-controls-enclosure {
  display: none;
}
</style>
